import { applyMiddleware, compose, createStore } from "redux"
import { isNil, reject } from "ramda"
import promise from "redux-promise-middleware"
import thunk from "redux-thunk"

import { router } from "../utils/router"
import reducer from "./reducers"

const t = (f: any) => f
// @ts-ignore
window.__REDUX_DEVTOOLS_EXTENSION__ = window.__REDUX_DEVTOOLS_EXTENSION__ || t

const middlewares = [
  applyMiddleware(thunk),
  applyMiddleware(promise),
  applyMiddleware(router),
  // @ts-ignore
  // applyMiddleware(logger),
  // Required only in development so that the logger is not shipped in the production bundle.
  process.env.NODE_ENV === "development"
    ? applyMiddleware(require("redux-logger").default)
    : t(undefined),
  // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION__(),
]

export const createStoreWithMiddleWare: any = compose(
  ...reject(isNil)(middlewares)
)(createStore)

const configureStore = () => {
  return createStoreWithMiddleWare(reducer)
}

export default configureStore()
